import { useState } from 'react';
import {
  AppBar, Toolbar, Typography, Button, Stack, Box,
  IconButton, Drawer, List, ListItem, ListItemButton,
  ListItemText, Divider
} from '@mui/material';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

const go = path => { window.location.href = path; };

const NAV_ITEMS = ['Fonctionnalités', 'Tournois', 'Profils', 'Tarifs'];

const Navbar = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          bgcolor: 'rgba(255,255,255,0.92)',
          backdropFilter: 'blur(20px)',
          borderBottom: '1px solid rgba(34,197,94,0.13)',
          boxShadow: '0 1px 24px rgba(60,160,60,0.07)',
        }}
      >
        <Toolbar
          sx={{
            maxWidth: 1200,
            mx: 'auto',
            width: '100%',
            px: { xs: 2, md: 3 },
            justifyContent: 'space-between',
          }}
        >
          {/* Logo */}
          <Stack direction="row" alignItems="center" spacing={1}>
            <Box
              sx={{
                width: 32,
                height: 32,
                borderRadius: '9px',
                background: 'linear-gradient(135deg, #22c55e, #16a34a)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 8px rgba(34,197,94,0.28)',
              }}
            >
              <SportsSoccerIcon sx={{ color: '#fff', fontSize: 18 }} />
            </Box>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 800,
                letterSpacing: -0.5,
                background: 'linear-gradient(135deg, #15803d, #22c55e)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              ProPlayeur
            </Typography>
          </Stack>

          {/* Desktop nav */}
          <Stack
            direction="row"
            spacing={0.5}
            alignItems="center"
            sx={{ display: { xs: 'none', md: 'flex' } }}
          >
            {NAV_ITEMS.map(item => (
              <Button
                key={item}
                sx={{
                  color: '#64748b',
                  fontWeight: 500,
                  fontSize: '0.875rem',
                  borderRadius: 2,
                  '&:hover': {
                    color: '#16a34a',
                    bgcolor: 'rgba(34,197,94,0.08)',
                  },
                  transition: 'all .18s',
                }}
              >
                {item}
              </Button>
            ))}
            <Box sx={{ ml: 1.5, display: 'flex', gap: 1 }}>
              <Button
                onClick={() => go('/login')}
                variant="outlined"
                size="small"
                sx={{
                  borderColor: 'rgba(34,197,94,0.4)',
                  borderWidth: '1.5px',
                  color: '#16a34a',
                  borderRadius: '9px',
                  fontWeight: 600,
                  '&:hover': {
                    borderColor: '#22c55e',
                    bgcolor: 'rgba(34,197,94,0.06)',
                    borderWidth: '1.5px',
                  },
                }}
              >
                Connexion
              </Button>
              <Button
                onClick={() => go('/login')}
                variant="contained"
                size="small"
                sx={{
                  background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
                  color: '#fff',
                  fontWeight: 700,
                  borderRadius: '9px',
                  boxShadow: '0 2px 10px rgba(34,197,94,0.3)',
                  '&:hover': {
                    background: 'linear-gradient(135deg, #16a34a 0%, #15803d 100%)',
                    boxShadow: '0 4px 14px rgba(34,197,94,0.38)',
                    transform: 'translateY(-1px)',
                  },
                  transition: 'all .18s',
                }}
              >
                S'inscrire
              </Button>
            </Box>
          </Stack>

          {/* Mobile hamburger */}
          <IconButton
            onClick={() => setDrawerOpen(true)}
            sx={{ display: { xs: 'flex', md: 'none' }, color: '#16a34a' }}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{
          sx: {
            width: 260,
            bgcolor: 'rgba(255,255,255,0.98)',
            borderLeft: '1px solid rgba(34,197,94,0.15)',
          },
        }}
      >
        {/* Drawer header */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: 2,
            py: 1.5,
            borderBottom: '1px solid rgba(34,197,94,0.12)',
          }}
        >
          <Stack direction="row" alignItems="center" spacing={1}>
            <Box
              sx={{
                width: 28,
                height: 28,
                borderRadius: '7px',
                background: 'linear-gradient(135deg, #22c55e, #16a34a)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <SportsSoccerIcon sx={{ color: '#fff', fontSize: 16 }} />
            </Box>
            <Typography
              sx={{
                fontWeight: 800,
                letterSpacing: -0.5,
                background: 'linear-gradient(135deg, #15803d, #22c55e)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              ProPlayeur
            </Typography>
          </Stack>
          <IconButton onClick={() => setDrawerOpen(false)} sx={{ color: '#94a3b8' }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        {/* Nav links */}
        <List sx={{ pt: 1 }}>
          {NAV_ITEMS.map(item => (
            <ListItem key={item} disablePadding>
              <ListItemButton
                onClick={() => setDrawerOpen(false)}
                sx={{
                  px: 3,
                  py: 1.2,
                  '&:hover': { bgcolor: 'rgba(34,197,94,0.07)' },
                }}
              >
                <ListItemText
                  primary={item}
                  primaryTypographyProps={{
                    sx: { color: '#475569', fontWeight: 500, fontSize: '0.95rem' },
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>

        <Divider sx={{ borderColor: 'rgba(34,197,94,0.12)', mx: 2, my: 1 }} />

        {/* CTA buttons */}
        <Stack spacing={1.5} sx={{ px: 2, pt: 1 }}>
          <Button
            onClick={() => go('/login')}
            variant="outlined"
            fullWidth
            sx={{
              borderColor: 'rgba(34,197,94,0.4)',
              borderWidth: '1.5px',
              color: '#16a34a',
              borderRadius: '9px',
              fontWeight: 600,
              '&:hover': {
                borderColor: '#22c55e',
                bgcolor: 'rgba(34,197,94,0.06)',
                borderWidth: '1.5px',
              },
            }}
          >
            Connexion
          </Button>
          <Button
            onClick={() => go('/login')}
            variant="contained"
            fullWidth
            sx={{
              background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
              color: '#fff',
              fontWeight: 700,
              borderRadius: '9px',
              boxShadow: '0 2px 10px rgba(34,197,94,0.3)',
              '&:hover': {
                background: 'linear-gradient(135deg, #16a34a 0%, #15803d 100%)',
                boxShadow: '0 4px 14px rgba(34,197,94,0.38)',
              },
            }}
          >
            S'inscrire
          </Button>
        </Stack>
      </Drawer>
    </>
  );
};

export default Navbar;